import React from "react";

const StoreIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#storeClipPath)">
      <path
        d="M5.49784 3.29649H11.3166V9.48662C11.3184 9.95023 11.2286 10.4096 11.0525 10.8385C10.8763 11.2673 10.6172 11.6571 10.29 11.9856C9.96283 12.3141 9.57401 12.5747 9.14587 12.7525C8.71772 12.9303 8.25867 13.0219 7.79506 13.0219H6.83215C6.36739 13.0237 5.90686 12.9335 5.47712 12.7565C5.04738 12.5795 4.65694 12.3191 4.3283 11.9905C3.99966 11.6618 3.73932 11.2714 3.5623 10.8417C3.38528 10.4119 3.29508 9.95139 3.2969 9.48662V5.49742C3.2969 4.9137 3.52879 4.35388 3.94154 3.94113C4.3543 3.52837 4.91411 3.29649 5.49784 3.29649V3.29649Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M11.3164 3.29649H19.3361V9.48662C19.3379 9.95139 19.2477 10.4119 19.0707 10.8417C18.8937 11.2714 18.6333 11.6618 18.3047 11.9905C17.9761 12.3191 17.5856 12.5795 17.1559 12.7565C16.7261 12.9335 16.2656 13.0237 15.8008 13.0219H14.8379C14.3743 13.0219 13.9153 12.9303 13.4871 12.7525C13.059 12.5747 12.6702 12.3141 12.343 11.9856C12.0158 11.6571 11.7567 11.2673 11.5805 10.8385C11.4044 10.4096 11.3146 9.95023 11.3164 9.48662V3.29649Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M11.3164 3.29649H18.6758V9.48662C18.6776 9.95139 18.5874 10.4119 18.4104 10.8417C18.2334 11.2714 17.9731 11.6618 17.6444 11.9905C17.3158 12.3191 16.9253 12.5795 16.4956 12.7565C16.0659 12.9335 15.6053 13.0237 15.1406 13.0219H14.8379C14.3743 13.0219 13.9153 12.9303 13.4871 12.7525C13.059 12.5747 12.6702 12.3141 12.343 11.9856C12.0158 11.6571 11.7567 11.2673 11.5805 10.8385C11.4044 10.4096 11.3146 9.95023 11.3164 9.48662V3.29649Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M19.3359 3.29649H25.361C25.6241 3.29467 25.8849 3.34493 26.1285 3.44435C26.3721 3.54378 26.5936 3.69041 26.7803 3.87581C26.967 4.0612 27.1151 4.2817 27.2162 4.5246C27.3173 4.76749 27.3694 5.02799 27.3694 5.29109V9.48662C27.3694 10.4206 26.9983 11.3163 26.3379 11.9767C25.6775 12.6371 24.7818 13.0081 23.8479 13.0081H22.8849C22.4202 13.0117 21.9593 12.9233 21.5289 12.748C21.0984 12.5727 20.707 12.3138 20.3771 11.9865C20.0471 11.6591 19.7853 11.2697 19.6066 10.8406C19.4279 10.4116 19.3359 9.95139 19.3359 9.48662V3.29649Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M19.3359 3.29649H24.3981C24.9271 3.29649 25.4344 3.50663 25.8085 3.88069C26.1825 4.25475 26.3927 4.76209 26.3927 5.29109V9.48662C26.3927 9.94907 26.3016 10.407 26.1246 10.8342C25.9477 11.2615 25.6883 11.6497 25.3613 11.9767C25.0343 12.3037 24.6461 12.5631 24.2188 12.7401C23.7916 12.917 23.3336 13.0081 22.8712 13.0081V13.0081C22.4076 13.0099 21.9482 12.9202 21.5193 12.744C21.0905 12.5679 20.7007 12.3088 20.3722 11.9816C20.0438 11.6544 19.7831 11.2656 19.6053 10.8374C19.4275 10.4093 19.3359 9.95023 19.3359 9.48662V3.29649Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M4.71338 12.4166V27.1079H25.9387V11.8664"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M4.71338 13.5033V26.31H25.0033V13.0219"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6619 18.1803H11.9766V27.1079H18.6619V18.1803Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M17.754 18.1803H11.9766V27.1079H17.754V18.1803Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="storeClipPath">
        <rect
          width="25.4208"
          height="25.187"
          fill="white"
          transform="translate(2.60889 2.6087)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default StoreIcon;
